export type Observer<T> = (value: T) => void;

/**
 * Observable is a simple implementation of the observer pattern.
 */
export class Observable<T> {
    private readonly observers: Observer<T>[] = [];

    /**
     * Subscribe to change events.
     * @param observer observer object
     */
    subscribe(observer: Observer<T>): void {
        this.observers.push(observer);
    }

    unsubscribe(observer: Observer<T>): void {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }

    notify(value: T): void {
        for (const observer of this.observers) {
            observer(value);
        }
    }
}
